import SEOTestPage from '../../components/SEOTestPage';
import { SEO_TESTS } from '../../data/seoTestsConfig';
export default function KaygiTestiPage() {
  return <SEOTestPage testConfig={SEO_TESTS['kaygi-testi']} />;
}
